import { useQuery } from '@tanstack/react-query'
import { photosService } from '@/api/services/photos.service'
import { queryKeys } from '@/api/query-keys'

export function usePhotoTopicsQuery(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.photos.topics(),
    queryFn: () => photosService.getTopics(),
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
